import React, { useState, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import FormEditInfoCorporate from './EditPerusahaan';
import axios from '../../../lib/axios'
import errorHandler from "../../../helpers/errorHandler";

const InfoPerusahaanCorporate = () => {

    const [user, setUser] = useState([])
    const [editInfoPerusahaan, setEditInfoPerusahaan] = useState(false);
    const account = user.Account !== undefined ? user.Account : ''

    const handleFetch = async () => {
        try {
            const options = {
                url: `/users/users`,
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                }
            }
            const { data } = await axios(options)
            setUser(data.data)
        } catch (err) {
            errorHandler({ err: err?.response?.data || err })
        }
    }

    const handleAfterSubmit = () => {
        setEditInfoPerusahaan(false)
        handleFetch()
    }

    useEffect(() => {
        handleFetch()
    }, [])

    return (
        <>
            <div className="card"
                style={{ backgroundColor: '#F2F2F2', borderRadius: '20px' }}
            >
                <div className="card-body d-flex justify-content-between">
                    <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#3F4254', marginTop: '10px' }} className="card-title">Informasi Perusahaan</h3>

                    <button class="btn btn-primary" onClick={() => setEditInfoPerusahaan(true)}>Edit</button>
                </div>
                <hr></hr>
                <div className="card-body">
                    <div className='row'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                Nama Perusahaan
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {account.name}
                            </p>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                No. NPWP Perusahaan
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {account.npwp}
                            </p>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                Jenis Perusahaan
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {account.companyType}
                            </p>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                Klasifikasi Indsutri
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {account.industryClassification}
                            </p>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                Telepon Perusahaan
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {account.phone}
                            </p>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                Alamat Perusahaan
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {account.billingStreet} &nbsp;
                                {account.billingSubdistrict} &nbsp;
                                {account.billingCity} &nbsp;
                                {account.billingState} &nbsp;
                                {account.billingCountry}
                            </p>
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-lg-5'>
                            <p style={{ color: '#868E96', fontSize: '16px', fontWeight: '400' }}>
                                Alamat Pengiriman Dokumen
                            </p>
                        </div>
                        <div className='col-lg-6'>
                            <p style={{ color: '#3F4254', fontSize: '14px', fontWeight: '700' }}>
                                {account.shippingStreet} &nbsp;
                                {account.shippingSubdistrict} &nbsp;
                                {account.shippingCity} &nbsp;
                                {account.shippingState} &nbsp;
                                {account.shippingCountry}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={editInfoPerusahaan}
                size='lg'
                onHide={() => setEditInfoPerusahaan(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header
                    closeButton
                    style={{ backgroundColor: '#F2F2F2' }}

                >
                    <Modal.Title>
                        <h3 className='mb-3'>Edit Informasi Perusahaan</h3>
                    </Modal.Title>
                </Modal.Header >
                <Modal.Body
                    style={{ backgroundColor: '#F2F2F2' }}

                >
                    <FormEditInfoCorporate
                        close={() => handleAfterSubmit()}
                        user={user}
                    />
                </Modal.Body>
            </Modal>

        </>
    )
}

export default InfoPerusahaanCorporate
